"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MouseOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MouseOutlineSVG = function MouseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M25.38,16.86,10.3,2.52A2,2,0,0,0,7,4L7,25a2,2,0,0,0,.89,1.66,1.93,1.93,0,0,0,1.86.15L14,23.16l2.16,5.05a3,3,0,0,0,1.63,1.59,3.07,3.07,0,0,0,1.07.2A2.8,2.8,0,0,0,20,29.75a3,3,0,0,0,1.52-3.89l-2.17-5.08,5.18-.58.29-.08a2,2,0,0,0,.56-3.26Zm-9,2.23,3.23,7.55a1,1,0,0,1-.49,1.28.94.94,0,0,1-.7,0,1,1,0,0,1-.52-.52L14.7,19.85,9,25V4L24,18Z"
  }));
};
exports.MouseOutlineSVG = MouseOutlineSVG;
MouseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MouseOutlineSVG);
exports.default = _default;